// Presentation geometry for the reference artwork's 2:3 canvas (320 × 480).
// Codes, surfaces, laterality and the save contract are unchanged. These paths
// describe the displayed anatomy, not a reclassification of persisted regions.
export const MUSCLE_SHAPES = {
  head: "M160 7 C149 7 142 14 142 26 L139 31 Q136 30 139 42 L143 53 Q146 60 154 62 L166 62 Q174 60 177 53 L181 42 Q184 30 181 31 L178 26 C178 14 171 7 160 7Z",
  neck: "M145 62 L175 62 Q174 73 188 78 L176 85 L160 87 L144 85 L132 78 Q146 73 145 62Z",
  chest: "M130 81 Q146 83 160 87 Q174 83 190 81 L201 106 L197 124 Q179 136 160 127 Q141 136 123 124 L119 106Z",
  upper_back: "M144 62 L160 70 L176 62 L191 77 L202 112 Q187 137 160 162 Q133 137 118 112 L129 77Z",
  lower_back: "M126 152 Q142 161 160 164 Q178 161 194 152 L201 188 Q180 207 160 224 Q140 207 119 188Z",
  abdomen: "M126 129 Q142 134 160 129 Q178 134 194 129 L201 184 L183 200 L160 222 L137 200 L119 184Z",
  shoulder: "M126 79 Q108 78 103 88 Q98 100 100 117 Q113 109 121 105 L132 85Z",
  shoulder_back: "M125 78 Q108 76 100 88 Q94 98 96 116 Q111 108 120 102 L130 84Z",
  upper_arm: "M99 111 Q110 110 120 106 L122 119 Q122 134 113 150 L96 155 L93 144Z",
  upper_arm_back: "M96 112 Q110 109 120 105 L122 119 Q121 134 111 150 L93 156 L90 142Z",
  elbow: "M92 149 Q104 154 112 151 L111 164 Q101 169 87 163Z",
  elbow_back: "M90 150 Q101 155 111 151 L109 167 Q96 171 83 165Z",
  forearm: "M86 166 Q98 171 109 168 Q106 184 97 197 L90 211 L76 206 L81 180Z",
  forearm_back: "M81 167 Q94 173 108 170 Q103 188 94 200 L89 213 L72 207 L77 181Z",
  hand: "M75 209 L89 215 L89 230 L88 246 Q87 260 82 254 Q79 266 75 258 Q70 265 68 258 Q64 261 64 254 L66 234 Q57 241 58 234 L65 224 L72 218Z",
  hand_back: "M72 209 L87 216 L88 231 L85 249 Q84 263 79 259 Q76 265 72 260 Q68 266 66 260 Q63 264 63 256 L65 234 Q55 241 57 234 L62 226 L69 219Z",
  hip: "M120 187 Q124 194 135 200 L133 227 L117 237 Q112 212 120 187Z",
  hip_back: "M120 188 Q140 187 158 216 L158 234 Q142 249 116 238 Q111 218 120 188Z",
  groin: "M137 201 L160 225 L159 242 Q145 239 132 226Z",
  thigh_front: "M115 238 Q134 233 158 242 L152 277 L150 303 Q137 311 122 303 L117 281 Q112 256 115 238Z",
  thigh_back: "M116 241 Q135 250 157 238 L154 270 L150 303 Q137 311 122 303 L117 281Z",
  knee: "M122 305 Q136 311 150 305 L148 326 Q133 334 120 325Z",
  shin: "M120 330 Q133 335 146 329 Q150 354 143 379 L136 409 L122 409 L117 377 Q110 352 120 330Z",
  calf: "M120 330 Q133 335 146 329 Q153 353 145 379 L137 409 L121 409 L116 377 Q107 352 120 330Z",
  ankle: "M121 411 L137 411 L140 431 Q131 438 119 430Z",
  foot: "M120 435 Q129 439 139 433 L139 447 Q145 456 131 459 Q116 460 108 453 L114 444Z",
  foot_back: "M120 434 Q129 438 138 432 L140 440 L149 443 Q150 449 140 449 Q138 455 129 455 Q117 454 117 448 Q107 449 108 443 L115 440Z",
};

// Slightly extended joint targets, still separated from the adjacent feet/limbs.
export const MUSCLE_JOINT_HITS = {
  neck: "M143 62 H177 V80 H143Z",
  elbow: "M85 148 H113 V166 H85Z",
  elbow_back: "M81 150 H112 V168 H81Z",
  knee: "M115 305 H151 V328 H115Z",
  ankle: "M116 411 H141 V433 H116Z",
};
